/** @jsx jsx */

import React, { useEffect, useRef, useState } from "react";
import { jsx, css } from "@emotion/react";
import Button from "@material-ui/core/Button";
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import MovieIcon from '@material-ui/icons/Movie'
import { createTheme, ThemeProvider } from "@material-ui/core/styles";

const theme = createTheme({
  overrides: {
    MuiButton: {
      sizeLarge: {
        "& $label": {
          font: "normal normal 700 1.25rem/1.875rem Open Sans",
        }
      }
    }
  }
});
/*
  NB css ref: http://www.standardista.com/px-to-rem-conversion-if-root-font-size-is-16px/
 */
const onePadding = css`
  padding-top:1em;
  padding-bottom:1em;
`;

const labelPadding = css`
  padding-left:1em;
`;

const buttonPadding = css`
  padding-left:2em;
  transform: scale(1);
`;

const btnGroup = css`
  width: 100%;
  display: flex;
`;

const btnChildDiv = css`
  width: 50%;
`;

interface UploaderFormProps {
  clickHandler: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleDownloadClick: (e: any) => void;
  isDisabled: boolean;
  isFileSelectDisabled: boolean
  fileNamelabel: string;
}

const UploaderForm: React.FC<UploaderFormProps> = (props) => {
  useEffect(() => {
    console.log("[DEBUG][UploaderForm] useEffect");
  });

  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const handleClick = event => {
    console.log(event);
    if (hiddenFileInput.current != null && hiddenFileInput.current != undefined) {
      hiddenFileInput.current.click();
    }
  };

  return (
    <div css={onePadding}>
      <h3 css={onePadding}>2.動画アップロード</h3>
      <ThemeProvider theme={theme}>
        <div css={btnGroup}>
          <div css={btnChildDiv}>
            <Button css={buttonPadding} size="large" color="default" startIcon={<MovieIcon />} variant="contained" disabled={props.isFileSelectDisabled} onClick={handleClick}>
              ファイルを選択
          </Button>
            <label css={labelPadding}>{props.fileNamelabel}</label>
          </div>
          <div css={btnChildDiv}>
            <Button css={buttonPadding} size="large" color="primary" startIcon={<CloudUploadIcon />} variant="contained" disabled={props.isDisabled} onClick={(e) => { props.handleDownloadClick(e) }}>
              &nbsp;&nbsp;アップロード&nbsp;
          </Button>
          </div>
        </div>
      </ThemeProvider>
      <input type='file' ref={hiddenFileInput} style={{ display: "none" }} onChange={props.clickHandler} />
    </div>
  );
};

export default UploaderForm;

